export const icerikler = {
  title: 'İçerikler',
  titleEN: 'Contens',
  description: 'Markanın hedef kitlesine gre liste ve quiz formatında hazırlanan, kullanıcıya olumlu bir Mackolik içeriği tecrbesi yaşatırken bir yandan native olarak marka ile tketiciyi buluşturan içerik modelidir.',
  descriptionEN: 'This is a content model designed in list and quiz formats according to the brand\'s target audience, providing users with a positive Mackolik content experience while natively connecting the brand with consumers.',
  tabs: [
    {
      id: 1,
      title: 'Liste İçeriği',
      sliderPerView: 1,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/246783a7ec9eb1d1d57a204785812dbe3c92285d6fa8f5ce53228b1817442cc0.png',
          url: 'https://www.mackolik.com/futbol/liste/bu-buyukluk-saka-mi/8bc37d77-533d-40de-8a41-26ebe80898f8',
          category: 'Liste İçeriği'
        }
      ]
    },
    {
      id: 2,
      title: 'Quiz / Test İçeriği',
      sliderPerView: 1,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/5e61156405504d070657b90eedb90051fc2f95f9b874f716221e535c513e6eaf.png',
          modal: 'image',
          modalTitle: 'Quiz/Test İçeriği',
          category: 'Quiz/Test İçeriği'
        }
      ]
    }
  ],
  egTabs: [
    {
      id: 1,
      title: 'List Content',
      sliderPerView: 1,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/246783a7ec9eb1d1d57a204785812dbe3c92285d6fa8f5ce53228b1817442cc0.png',
          url: 'https://www.mackolik.com/futbol/liste/bu-buyukluk-saka-mi/8bc37d77-533d-40de-8a41-26ebe80898f8',
          category: 'List Content'
        }
      ]
    },
    {
      id: 2,
      title: 'Quiz / Test Content',
      sliderPerView: 1,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/5e61156405504d070657b90eedb90051fc2f95f9b874f716221e535c513e6eaf.png',
          modal: 'image',
          modalTitle: 'Quiz / Test Content',
          category: 'Quiz / Test Content'
        }
      ]
    }
  ]
}
